import React from 'react';
import { useAppSelector } from '../../../../../app/hooks';
import { useTheme } from 'styled-components';
import { LoaderContainerShadow } from '../styles';
import { LoaderEnum, MiniLoader } from '../../../../../ui/Loader/MiniLoader';

export const RegFromLoader = () => {
	const Theme = useTheme();
	const { registerInitDataFetching } = useAppSelector(state => state.auth);

	if (registerInitDataFetching) {
		<LoaderContainerShadow>
			<MiniLoader color={Theme.color.indicator} size={LoaderEnum.medium} />
		</LoaderContainerShadow>;
	}

	return null;
};
